import React from 'react'
import {  useDispatch } from "react-redux";
import Loader from 'Components/Loader';
import { useState } from 'react';
import { useEffect } from 'react';
import api from 'utils/api';
import { message } from 'antd';
import { useHistory } from "react-router-dom";
import { setGuestUUID } from 'store/slice/assessment-slice';
import { setApiResult } from 'store/slice/dynamic-linking-slice';

function DementiaAssessmentLinking(props) {
    const [loading,setLoading]=useState(true);
    const dispatch = useDispatch();    
    const history = useHistory();
    useEffect(DynamicApi,[])      
    function CallBack(dynamiclink){
      if(dynamiclink){        
      dispatch(setGuestUUID(dynamiclink?.identifier?.uuid));
      history.push({
        pathname: "/guest-user/sign-up",    //redirect to initial screen instead of login screen
        dispatch: { dispatch },
        frompath: "/assessment-completion",
        type: dynamiclink?.identifier?.type || "adult",
        history: props,
        state:{assessmentCompleted:true}
      })}
    }
    function DynamicApi(){
    let url = new URL(window.location.href);
    const { search } = location;
    const queryParams = new URLSearchParams(search);
    const queryParamString = queryParams.toString();
    if(queryParamString !== ""){
      sessionStorage.setItem("memcheck-link",window.location.href);
    }
    else if(sessionStorage.getItem("memcheck-link")){
      url = new URL(sessionStorage.getItem("memcheck-link"));
    }
    if (url.searchParams.toString() !== "") {
      const payload={
        "url":url,};
      api
        .dynamic_linking(payload).then((response) => {
          if (response.data?.status === 200) {  
             dispatch( setApiResult(response.data?.data));
            sessionStorage.setItem("dynamiclink", true);          
            CallBack(response.data?.data);
          } else {
            message.error(response.data?.message);
            history.push({
              pathname: "/",    //redirect to initial screen instead of login screen             
            })
          }
        })
        .catch((err) => {
          message.error("Something went wrong. Please try after sometime.");
        })
        .finally(() => {
          setLoading(false);
        });
    }
    else{
      history.push({
        pathname: "/",    //redirect to initial screen instead of login screen             
      })
      setLoading(false);
    }
  }
  
    return<>{loading?<Loader/>:<></>}</>
}

export default DementiaAssessmentLinking